// Market data stream (SPEC §7.3, §7.4, §12.0). Carried on /v1/stream/md only.

// @generated by protoc-gen-es v2.15.0 with parameter "target=ts,import_extension=none"
// @generated from file helm/v1/market_data.proto (package helm.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file helm/v1/market_data.proto.
 */
export const file_helm_v1_market_data: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message helm.v1.Subscribe
 */
export type Subscribe = Message<"helm.v1.Subscribe"> & {
  /**
   * "NQZ6"
   *
   * @generated from field: string symbol = 1;
   */
  symbol: string;

  /**
   * @generated from field: bool want_book = 2;
   */
  wantBook: boolean;

  /**
   * @generated from field: bool want_trades = 3;
   */
  wantTrades: boolean;

  /**
   * @generated from field: bool want_bbo = 4;
   */
  wantBbo: boolean;
};

/**
 * Describes the message helm.v1.Subscribe.
 * Use `create(SubscribeSchema)` to create a new message.
 */
export const SubscribeSchema: GenMessage<Subscribe> = /*@__PURE__*/
  messageDesc(file_helm_v1_market_data, 0);

/**
 * @generated from message helm.v1.Unsubscribe
 */
export type Unsubscribe = Message<"helm.v1.Unsubscribe"> & {
  /**
   * @generated from field: string symbol = 1;
   */
  symbol: string;
};

/**
 * Describes the message helm.v1.Unsubscribe.
 * Use `create(UnsubscribeSchema)` to create a new message.
 */
export const UnsubscribeSchema: GenMessage<Unsubscribe> = /*@__PURE__*/
  messageDesc(file_helm_v1_market_data, 1);

/**
 * Tick size as an exact rational so the client never sees a float tick (SPEC §7.3).
 *
 * @generated from message helm.v1.InstrumentInfo
 */
export type InstrumentInfo = Message<"helm.v1.InstrumentInfo"> & {
  /**
   * @generated from field: string symbol = 1;
   */
  symbol: string;

  /**
   * @generated from field: string root = 2;
   */
  root: string;

  /**
   * @generated from field: string exchange = 3;
   */
  exchange: string;

  /**
   * @generated from field: uint32 tick_size_num = 4;
   */
  tickSizeNum: number;

  /**
   * @generated from field: uint32 tick_size_den = 5;
   */
  tickSizeDen: number;

  /**
   * @generated from field: sint64 tick_value_cents = 6;
   */
  tickValueCents: bigint;

  /**
   * @generated from field: uint32 ticks_per_point = 7;
   */
  ticksPerPoint: number;

  /**
   * @generated from field: uint32 display_decimals = 8;
   */
  displayDecimals: number;

  /**
   * YYYY-MM-DD
   *
   * @generated from field: string expiry = 9;
   */
  expiry: string;

  /**
   * @generated from field: bool is_micro = 10;
   */
  isMicro: boolean;

  /**
   * @generated from field: string mini_equivalent = 11;
   */
  miniEquivalent: string;
};

/**
 * Describes the message helm.v1.InstrumentInfo.
 * Use `create(InstrumentInfoSchema)` to create a new message.
 */
export const InstrumentInfoSchema: GenMessage<InstrumentInfo> = /*@__PURE__*/
  messageDesc(file_helm_v1_market_data, 2);

/**
 * Sent IMMEDIATELY per Rithmic message (usually 1 trade); multiple trades only when coalesced
 * under backpressure (SPEC §7.4, §12.0 stage 3).
 *
 * @generated from message helm.v1.TradeBatch
 */
export type TradeBatch = Message<"helm.v1.TradeBatch"> & {
  /**
   * @generated from field: string symbol = 1;
   */
  symbol: string;

  /**
   * @generated from field: repeated sint64 price_ticks = 2 [packed = true];
   */
  priceTicks: bigint[];

  /**
   * @generated from field: repeated uint32 size = 3 [packed = true];
   */
  size: number[];

  /**
   * 1 buy, 2 sell, 0 unknown
   *
   * @generated from field: repeated uint32 aggressor = 4 [packed = true];
   */
  aggressor: number[];

  /**
   * exchange time
   *
   * @generated from field: repeated fixed64 ts_ns = 5 [packed = true];
   */
  tsNs: bigint[];

  /**
   * gateway receive time, for tick-to-pixel (§12.0)
   *
   * @generated from field: repeated fixed64 gw_recv_ns = 6 [packed = true];
   */
  gwRecvNs: bigint[];
};

/**
 * Describes the message helm.v1.TradeBatch.
 * Use `create(TradeBatchSchema)` to create a new message.
 */
export const TradeBatchSchema: GenMessage<TradeBatch> = /*@__PURE__*/
  messageDesc(file_helm_v1_market_data, 3);

/**
 * Full top-N levels each frame (N<=10 MBP). MBO-derived deltas arrive as BookDelta (§12.8.2).
 *
 * @generated from message helm.v1.BookUpdate
 */
export type BookUpdate = Message<"helm.v1.BookUpdate"> & {
  /**
   * @generated from field: string symbol = 1;
   */
  symbol: string;

  /**
   * @generated from field: fixed64 ts_ns = 2;
   */
  tsNs: bigint;

  /**
   * @generated from field: repeated sint64 bid_ticks = 3 [packed = true];
   */
  bidTicks: bigint[];

  /**
   * @generated from field: repeated uint32 bid_size = 4 [packed = true];
   */
  bidSize: number[];

  /**
   * @generated from field: repeated sint64 ask_ticks = 5 [packed = true];
   */
  askTicks: bigint[];

  /**
   * @generated from field: repeated uint32 ask_size = 6 [packed = true];
   */
  askSize: number[];

  /**
   * true when MBO is unavailable and this is the 10-level fallback
   *
   * @generated from field: bool limited_depth = 7;
   */
  limitedDepth: boolean;
};

/**
 * Describes the message helm.v1.BookUpdate.
 * Use `create(BookUpdateSchema)` to create a new message.
 */
export const BookUpdateSchema: GenMessage<BookUpdate> = /*@__PURE__*/
  messageDesc(file_helm_v1_market_data, 4);

/**
 * @generated from message helm.v1.BookDelta
 */
export type BookDelta = Message<"helm.v1.BookDelta"> & {
  /**
   * @generated from field: string symbol = 1;
   */
  symbol: string;

  /**
   * @generated from field: fixed64 ts_ns = 2;
   */
  tsNs: bigint;

  /**
   * @generated from field: repeated sint64 price_ticks = 3 [packed = true];
   */
  priceTicks: bigint[];

  /**
   * 0 = level removed on that side
   *
   * @generated from field: repeated uint32 bid_size = 4 [packed = true];
   */
  bidSize: number[];

  /**
   * @generated from field: repeated uint32 ask_size = 5 [packed = true];
   */
  askSize: number[];
};

/**
 * Describes the message helm.v1.BookDelta.
 * Use `create(BookDeltaSchema)` to create a new message.
 */
export const BookDeltaSchema: GenMessage<BookDelta> = /*@__PURE__*/
  messageDesc(file_helm_v1_market_data, 5);

/**
 * @generated from message helm.v1.Bbo
 */
export type Bbo = Message<"helm.v1.Bbo"> & {
  /**
   * @generated from field: string symbol = 1;
   */
  symbol: string;

  /**
   * @generated from field: fixed64 ts_ns = 2;
   */
  tsNs: bigint;

  /**
   * @generated from field: sint64 bid_ticks = 3;
   */
  bidTicks: bigint;

  /**
   * @generated from field: uint32 bid_size = 4;
   */
  bidSize: number;

  /**
   * @generated from field: sint64 ask_ticks = 5;
   */
  askTicks: bigint;

  /**
   * @generated from field: uint32 ask_size = 6;
   */
  askSize: number;
};

/**
 * Describes the message helm.v1.Bbo.
 * Use `create(BboSchema)` to create a new message.
 */
export const BboSchema: GenMessage<Bbo> = /*@__PURE__*/
  messageDesc(file_helm_v1_market_data, 6);

/**
 * @generated from message helm.v1.SessionStats
 */
export type SessionStats = Message<"helm.v1.SessionStats"> & {
  /**
   * @generated from field: string symbol = 1;
   */
  symbol: string;

  /**
   * @generated from field: fixed64 ts_ns = 2;
   */
  tsNs: bigint;

  /**
   * @generated from field: sint64 open_ticks = 3;
   */
  openTicks: bigint;

  /**
   * @generated from field: sint64 high_ticks = 4;
   */
  highTicks: bigint;

  /**
   * @generated from field: sint64 low_ticks = 5;
   */
  lowTicks: bigint;

  /**
   * @generated from field: sint64 close_ticks = 6;
   */
  closeTicks: bigint;

  /**
   * @generated from field: sint64 settlement_ticks = 7;
   */
  settlementTicks: bigint;

  /**
   * @generated from field: uint64 volume = 8;
   */
  volume: bigint;
};

/**
 * Describes the message helm.v1.SessionStats.
 * Use `create(SessionStatsSchema)` to create a new message.
 */
export const SessionStatsSchema: GenMessage<SessionStats> = /*@__PURE__*/
  messageDesc(file_helm_v1_market_data, 7);

/**
 * Bar specification shared by history requests and live aggregation (SPEC §12.2, §12.3).
 *
 * @generated from message helm.v1.BarSpec
 */
export type BarSpec = Message<"helm.v1.BarSpec"> & {
  /**
   * @generated from field: helm.v1.BarSpec.Kind kind = 1;
   */
  kind: BarSpec_Kind;

  /**
   * seconds/minutes/ticks/contracts/range-ticks depending on kind
   *
   * @generated from field: uint32 period = 2;
   */
  period: number;
};

/**
 * Describes the message helm.v1.BarSpec.
 * Use `create(BarSpecSchema)` to create a new message.
 */
export const BarSpecSchema: GenMessage<BarSpec> = /*@__PURE__*/
  messageDesc(file_helm_v1_market_data, 8);

/**
 * @generated from enum helm.v1.BarSpec.Kind
 */
export enum BarSpec_Kind {
  /**
   * @generated from enum value: KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: KIND_SECOND = 1;
   */
  SECOND = 1,

  /**
   * @generated from enum value: KIND_MINUTE = 2;
   */
  MINUTE = 2,

  /**
   * @generated from enum value: KIND_DAILY = 3;
   */
  DAILY = 3,

  /**
   * @generated from enum value: KIND_WEEKLY = 4;
   */
  WEEKLY = 4,

  /**
   * @generated from enum value: KIND_TICK = 5;
   */
  TICK = 5,

  /**
   * @generated from enum value: KIND_VOLUME = 6;
   */
  VOLUME = 6,

  /**
   * @generated from enum value: KIND_RANGE = 7;
   */
  RANGE = 7,

  /**
   * 1-tick replay: one trade per record (§6.8)
   *
   * @generated from enum value: KIND_RAW_TRADES = 8;
   */
  RAW_TRADES = 8,
}

/**
 * Describes the enum helm.v1.BarSpec.Kind.
 */
export const BarSpec_KindSchema: GenEnum<BarSpec_Kind> = /*@__PURE__*/
  enumDesc(file_helm_v1_market_data, 8, 0);

/**
 * @generated from message helm.v1.HistoryRequest
 */
export type HistoryRequest = Message<"helm.v1.HistoryRequest"> & {
  /**
   * @generated from field: string symbol = 1;
   */
  symbol: string;

  /**
   * @generated from field: helm.v1.BarSpec spec = 2;
   */
  spec?: BarSpec | undefined;

  /**
   * @generated from field: fixed64 from_ns = 3;
   */
  fromNs: bigint;

  /**
   * @generated from field: fixed64 to_ns = 4;
   */
  toNs: bigint;

  /**
   * SPEC-ADDENDA A1: bypass server cache for this window
   *
   * @generated from field: bool force_reload = 5;
   */
  forceReload: boolean;
};

/**
 * Describes the message helm.v1.HistoryRequest.
 * Use `create(HistoryRequestSchema)` to create a new message.
 */
export const HistoryRequestSchema: GenMessage<HistoryRequest> = /*@__PURE__*/
  messageDesc(file_helm_v1_market_data, 9);

/**
 * @generated from message helm.v1.Bar
 */
export type Bar = Message<"helm.v1.Bar"> & {
  /**
   * bar OPEN time (SPEC §11A.2 convention)
   *
   * @generated from field: fixed64 open_ns = 1;
   */
  openNs: bigint;

  /**
   * @generated from field: sint64 open_ticks = 2;
   */
  openTicks: bigint;

  /**
   * @generated from field: sint64 high_ticks = 3;
   */
  highTicks: bigint;

  /**
   * @generated from field: sint64 low_ticks = 4;
   */
  lowTicks: bigint;

  /**
   * @generated from field: sint64 close_ticks = 5;
   */
  closeTicks: bigint;

  /**
   * @generated from field: uint64 volume = 6;
   */
  volume: bigint;

  /**
   * @generated from field: uint32 trade_count = 7;
   */
  tradeCount: number;

  /**
   * 0 when the source has no aggressor data
   *
   * @generated from field: uint64 bid_volume = 8;
   */
  bidVolume: bigint;

  /**
   * @generated from field: uint64 ask_volume = 9;
   */
  askVolume: bigint;
};

/**
 * Describes the message helm.v1.Bar.
 * Use `create(BarSchema)` to create a new message.
 */
export const BarSchema: GenMessage<Bar> = /*@__PURE__*/
  messageDesc(file_helm_v1_market_data, 10);

/**
 * @generated from message helm.v1.HistoryChunk
 */
export type HistoryChunk = Message<"helm.v1.HistoryChunk"> & {
  /**
   * @generated from field: string req_id = 1;
   */
  reqId: string;

  /**
   * @generated from field: string symbol = 2;
   */
  symbol: string;

  /**
   * @generated from field: helm.v1.BarSpec spec = 3;
   */
  spec?: BarSpec | undefined;

  /**
   * @generated from field: fixed64 from_ns = 4;
   */
  fromNs: bigint;

  /**
   * @generated from field: fixed64 to_ns = 5;
   */
  toNs: bigint;

  /**
   * @generated from field: repeated helm.v1.Bar bars = 6;
   */
  bars: Bar[];

  /**
   * last chunk for this request
   *
   * @generated from field: bool final = 7;
   */
  final: boolean;

  /**
   * window could not be filled after retries (SPEC §6.8 gap band)
   *
   * @generated from field: bool gap = 8;
   */
  gap: boolean;

  /**
   * SPEC-ADDENDA A1: budget exhausted; client shows "History paused"
   *
   * @generated from field: bool rate_limited = 9;
   */
  rateLimited: boolean;

  /**
   * bar count as recorded at fetch time (A1 suspect detection)
   *
   * @generated from field: uint32 checksum_bars = 10;
   */
  checksumBars: number;
};

/**
 * Describes the message helm.v1.HistoryChunk.
 * Use `create(HistoryChunkSchema)` to create a new message.
 */
export const HistoryChunkSchema: GenMessage<HistoryChunk> = /*@__PURE__*/
  messageDesc(file_helm_v1_market_data, 11);

/**
 * Live market data of `symbol` may be missing for [from_ns, to_ns) (exchange/wall ns): the
 * ticker plant dropped and `symbol` was re-subscribed after reconnecting (SPEC §6.12, CB3). Sent
 * on the md socket to every client holding the symbol; charts back-fill the window from history
 * and keep its bars out of the seam check.
 *
 * @generated from message helm.v1.MarketDataGap
 */
export type MarketDataGap = Message<"helm.v1.MarketDataGap"> & {
  /**
   * resolved contract ("NQZ6")
   *
   * @generated from field: string symbol = 1;
   */
  symbol: string;

  /**
   * last update received for the symbol before the drop (or the drop)
   *
   * @generated from field: fixed64 from_ns = 2;
   */
  fromNs: bigint;

  /**
   * re-subscribed
   *
   * @generated from field: fixed64 to_ns = 3;
   */
  toNs: bigint;

  /**
   * human-readable
   *
   * @generated from field: string reason = 4;
   */
  reason: string;
};

/**
 * Describes the message helm.v1.MarketDataGap.
 * Use `create(MarketDataGapSchema)` to create a new message.
 */
export const MarketDataGapSchema: GenMessage<MarketDataGap> = /*@__PURE__*/
  messageDesc(file_helm_v1_market_data, 12);

/**
 * @generated from message helm.v1.SymbolSearch
 */
export type SymbolSearch = Message<"helm.v1.SymbolSearch"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;
};

/**
 * Describes the message helm.v1.SymbolSearch.
 * Use `create(SymbolSearchSchema)` to create a new message.
 */
export const SymbolSearchSchema: GenMessage<SymbolSearch> = /*@__PURE__*/
  messageDesc(file_helm_v1_market_data, 13);

/**
 * @generated from message helm.v1.SymbolSearchResult
 */
export type SymbolSearchResult = Message<"helm.v1.SymbolSearchResult"> & {
  /**
   * @generated from field: repeated helm.v1.InstrumentInfo matches = 1;
   */
  matches: InstrumentInfo[];
};

/**
 * Describes the message helm.v1.SymbolSearchResult.
 * Use `create(SymbolSearchResultSchema)` to create a new message.
 */
export const SymbolSearchResultSchema: GenMessage<SymbolSearchResult> = /*@__PURE__*/
  messageDesc(file_helm_v1_market_data, 14);

